// extracted by mini-css-extract-plugin
export default {"root":"TtYZig","header":"fmxtbg","tabs":"banaTY"};